import 'reflect-metadata';
import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import 'core-js/es/array/at';
import { UserService } from '~/services/user.service';

function navigateByQueryZone(to: any) {
  // 1. 提取并验证 zone 参数
  const zone = to.query.zone;
  const ZONES = ['cpp', 'python']
  if (!zone || !ZONES.includes(zone as string)) return
  // 2. 检查当前路径是否已包含正确前缀（防循环）
  const expectedPrefix = `/${zone}/`
  if (to.href.includes(expectedPrefix)) return

  // 3. 构建完整路径字符串（核心逻辑）
  const newPath = `/${zone}${to.path.startsWith('/') ? '' : '/'}${to.path}`
  const queryString = new URLSearchParams(to.query as Record<string, string>).toString()
  const fullUrl = `${newPath}${queryString ? `?${queryString}` : ''}${to.hash || ''}`

  // 4. 触发跳转（字符串传参）
  return navigateTo(fullUrl, {
    replace: true,
    external: true //经试true才能跳转到新的zone
  })
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.client) {
    const userService = useRootService(UserService);

    if (to.fullPath.includes('/admin')) {
      // 默认admin下面的所有页面都需要管理员权限
      if (!userService.hasAdminPermission()) {
        return navigateTo('/');
      }
    } else if (to.meta.auth) {
      // 需要登录的页面需要在definePageMeta配置auth字段
      if (!userService.isLogin()) {
        return navigateTo('/');
      }
    }
    return navigateByQueryZone(to);
  }
});
